import { NavigationContainer } from '@react-navigation/native';
import { useFonts } from 'expo-font';
import ContextContainer from './context/ContextContainer';
import { ThemeProvider } from './context/ThemeContext';
import { BackgroundQueryProvider } from './context/BackgroundQueryContext';
import React, { useEffect, useMemo, useState } from 'react';
import { View, StyleSheet, Platform, Text } from 'react-native';
import LoadingScreen from './screens/LoadingScreen';
import SignInScreen from './screens/SignInScreen';
import MainPage from './MainPage';
import RegisterScreen from './screens/RegisterScreen';
import HomeScreen from './screens/HomeScreen';
import ExploreScreen from './screens/ExploreScreen';
import ForgotPasswordScreen from './screens/ForgotPasswordScreen';
import ProfilePage from './screens/ProfilePage';
import SameGameParlay from './screens/SameGameParlay';
import SgpFlowScreen from './screens/SgpFlowScreen';
import UnifiedSearchScreen from './screens/UnifiedSearchScreen';
import BackgroundQueryModal from './components/BackgroundQueryModal';
// duplicate import removed
import PlansScreen from './screens/PlansScreen';
import SuspendedScreen from './screens/SuspendedScreen';
import SuccessScreen from './screens/SuccessScreen';
import AdminScreen from './AdminScreen';
// duplicate import removed
import { useNavigation } from './context/NavigationContext';
import { useLoading } from './context/LoadingContext';
import AdminLogin from './AdminLogin';

// Font imports
const ClimateCrisisFont = require('./assets/fonts/ClimateCrisis-Regular-VariableFont_YEAR.ttf');
const SlateFont = require('./assets/fonts/SlateRg.TTF');
const ShantellSansFont = require('./assets/fonts/ShantellSans-VariableFont_BNCE,INFM,SPAC,wght.ttf');

function ScreenRouter() {
  const { currentScreen } = useNavigation();

  const renderScreen = () => {
    switch (currentScreen) {
      case 'MainPage':
        return <MainPage />;
      case 'Login':
        return <SignInScreen />;
      case 'Register':
        return <RegisterScreen />;
      case 'ForgotPassword':
        return <ForgotPasswordScreen />;
      case 'Home':
        return <HomeScreen />;
      case 'Dashboard':
        return <HomeScreen />;
      case 'Explore':
        return <ExploreScreen />;
      case 'SameGameParlay':
        return <SameGameParlay />;
      case 'SgpFlow':
        return <SgpFlowScreen />;
      case 'UnifiedSearch':
        return <UnifiedSearchScreen />;
      case 'Profile':
        return <ProfilePage />; 
      case 'Plans':
        return <PlansScreen />;
      case 'Suspended':
        return <SuspendedScreen />;
      case 'Success':
        return <SuccessScreen />;
      case 'Admin':
        return <AdminScreen />;
      case 'AdminLogin':
        return <AdminLogin />;
      default:
        return <HomeScreen />;
    }
  };

  return renderScreen();
}

function AppContent() {
  const { finishLoading, loadingDone } = useLoading();

  return (
    <View style={styles.root}>
      <ScreenRouter />
      {/* Background Query Modal - floats in bottom right corner */}
      <BackgroundQueryModal />
      {!loadingDone && (
        <View style={styles.loadingOverlay}>
          <LoadingScreen onFinish={finishLoading} />
        </View>
      )}
    </View>
  );
}

export default function App() {

  // ✅ FIX: Check if fonts are loaded before rendering
  const [fontsLoaded, fontError] = useFonts({
    ClimateCrisis: ClimateCrisisFont,
    Slate: SlateFont,
    ShantellSans: ShantellSansFont,
  });

  // Set title immediately on app load
  React.useEffect(() => {
    if (typeof document !== 'undefined') {
      document.title = 'Bet Optimized';
    }
  }, []);

  // ✅ FIX: Wait for fonts to load (prevents mobile white screen)
  if (!fontsLoaded && !fontError) {
    return (
      <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center', backgroundColor: '#000' }}>
        <Text style={{ color: '#fff' }}>Loading fonts...</Text>
      </View>
    );
  }

  // ✅ FIX: Show error if fonts fail to load
  if (fontError) {
    console.error('Font loading error:', fontError);
    // Still render app even if fonts fail (graceful degradation)
  }

  return (
    <NavigationContainer>
      <ContextContainer>
        <ThemeProvider>
          <BackgroundQueryProvider>
          <AppContent />
          </BackgroundQueryProvider>
        </ThemeProvider>
      </ContextContainer>
    </NavigationContainer>
  );
}

const styles = StyleSheet.create({
  root: { flex: 1 },
  loadingOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
});